import { Avatar, Space } from "antd";

const UserInfoWithId = ({ text }) => {
    return <Space direction="horizontal">
        <Avatar src={`${process.env.FILE_URL}${text.avatar}`} shape="circle" size={"default"} />
        <Space direction="vertical" size={0}>
            <h4 className="font-semibold m-0">{text?.firstName + ' ' + text?.lastName}</h4>
            <h4 className="m-0">{text?.employeeId}</h4>
        </Space>
    </Space>
}


export default UserInfoWithId;